import { render, staticRenderFns } from "./MyCheckboxGroup.vue?vue&type=template&id=2abdb3d2&scoped=true&"
import script from "./MyCheckboxGroup.vue?vue&type=script&lang=ts&"
export * from "./MyCheckboxGroup.vue?vue&type=script&lang=ts&"
import style0 from "./MyCheckboxGroup.vue?vue&type=style&index=0&id=2abdb3d2&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abdb3d2",
  null
  
)

export default component.exports